<template>
  <div class="vows-page">
    <navbar :isApp="isApp"></navbar>
    <navtool :fromTo='5' ></navtool>
    <div class="head-content">
      <img class="head-content-img" src="../../../assets/vows/banner.png" />
    </div>
    <div class="mainnav-line">
      <div
        class="mainnav-black"
        v-for="(maintag,$index) in menuNav"
        :key="$index"
        @click="toggleMainTags(maintag.vowsType1)"
      >
        <div
          :class="[maintag.vowsType1 == vowsType1 ? 'mainnav-tags-select':'mainnav-tags']"
        >{{maintag.name}}</div>
        <div class="mainnav-tags-select-wire" v-if="maintag.vowsType1 == vowsType1"></div>
      </div>
    </div>
    <div class="subnav-line" v-if="vowsType1 != 3">
      <div
        class="subnav-black"
        v-for="(subtag,$index) in menuNav[vowsType1-1].list"
        :key="$index"
        :id="'subnavBlack'+$index"
        @click="toggleSubTags(subtag.vowsType2)"
      >
        <div
          :class="[subtag.vowsType2 == vowsType2 ? 'subnav-black-button-select':'subnav-black-button']"
        >{{subtag.name}}</div>
      </div>
    </div>
    <div class="swiper-container">
      <div class="swiper-wrapper" v-if="vowsType1!=3">
        <div
          class="swiper-slide"
          v-for="(subtag,$index) in menuNav[vowsType1-1].list"
          :key="$index"
        >
          <div class="swiper-main-slide-black" v-for="(vows,$i) in subtag.data" :key="'data'+$i">
            <div :class="[vows.openState ? 'swiper-main-text-all':'swiper-main-text']">
              <div>{{vows.vowsMsg}}</div>
            </div>
            <div
              v-if="vows.openState"
              class="vows-msg-pack-up"
              @click="vowsMsgOpen(vowsType1,vowsType2,$i)"
            >
              收起
              <img
                class="vows-msg-arrow-img" 
                src="../../../assets/vows/upArrow.png"
              />
            </div>
            <div
              v-if="!vows.openState"
              class="vows-msg-open-up"
              @click="vowsMsgOpen(vowsType1,vowsType2,$i)"
            >
              查看全文
              <img
                class="vows-msg-arrow-img"
                src="../../../assets/vows/downArrow.png" 
              />
            </div>
            <div class="swiper-main-btn-line">
              <div
                :class="[isGreater ? 'swiper-main-btn-lateral copy-line action_post_web_data':'swiper-main-btn-lateral-line copy-line action_post_web_data']"
                :data-action="`{'actionName':'vows_copy'}`"
                @click="copyLink(vows.vowsMsg,vows.vowsId,$i)"
              >
                复制文章(
                <img class="swiper-main-btn-copy-img" src="../../../assets/vows/copy.png" />
                <div class="text-line">{{vows.vowsCopyCount}})</div>
              </div>
              <div class="swiper-main-btn-lateral action_post_web_data" :data-action="`{'actionName':'vows_share'}`" v-if="isGreater" @click="goUrl('ciw://wedding/speech?vowsId='+vows.vowsId)">
                分享
                <img class="swiper-main-btn-share-img" src="../../../assets/vows/share.png" />
              </div>
            </div>
            <div class="swiper-main-slide-black-flower">
              <img
                v-if="$i%6==0"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower0.png"
              />
              <img
                v-else-if="$i%6==1"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower1.png"
              />
              <img
                v-else-if="$i%6==2"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower2.png"
              />
              <img
                v-else-if="$i%6==3"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower3.png"
              />
              <img
                v-else-if="$i%6==4"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower4.png"
              />
              <img
                v-else-if="$i%6==5"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower5.png"
              />
            </div>
          </div>
          <div style="height:1.5rem;width:100%;"></div>
          <!-- <div class="swiper-bottom-text">和你一起走到世界的尽头</div> -->
        </div>
      </div>
      <div class="swiper-wrapper" v-if="vowsType1==3">
        <div class="swiper-slide">
          <div
            class="swiper-main-slide-black"
            v-for="(vows,$i) in menuNav[vowsType1-1].data"
            :key="'data'+$i"
          >
            <div :class="[vows.openState ? 'swiper-main-text-all':'swiper-main-text']">
              <div>{{vows.vowsMsg}}</div>
            </div>
            <div
              v-if="vows.openState"
              class="vows-msg-pack-up"
              @click="vowsMsgOpen(vowsType1,vowsType2,$i)"
            >
              收起
              <img
                class="vows-msg-arrow-img"
                src="../../../assets/vows/upArrow.png"
              />
            </div>
            <div
              v-if="!vows.openState"
              class="vows-msg-open-up"
              @click="vowsMsgOpen(vowsType1,vowsType2,$i)"
            >
              查看全文
              <img
                class="vows-msg-arrow-img"
                src="../../../assets/vows/downArrow.png" 
              />
            </div>
            <div class="swiper-main-btn-line">
              <div
                :class="[isGreater ? 'swiper-main-btn-lateral copy-line action_post_web_data':'swiper-main-btn-lateral-line copy-line action_post_web_data']"
                :data-action="`{'actionName':'vows_copy'}`"
                @click="copyLink(vows.vowsMsg,vows.vowsId,$i)"
              >
                复制文章(
                <img class="swiper-main-btn-copy-img" src="../../../assets/vows/copy.png" />
                <div class="text-line">{{vows.vowsCopyCount}})</div>
              </div>
              <div class="swiper-main-btn-lateral action_post_web_data" :data-action="`{'actionName':'vows_share'}`" v-if="isGreater" @click="goUrl('ciw://wedding/speech?vowsId='+vows.vowsId)">
                分享
                <img class="swiper-main-btn-share-img" src="../../../assets/vows/share.png" />
              </div>
            </div>
            <div class="swiper-main-slide-black-flower">
              <img
                v-if="$i%6==0"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower0.png"
              />
              <img
                v-else-if="$i%6==1"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower1.png"
              />
              <img
                v-else-if="$i%6==2"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower2.png"
              />
              <img
                v-else-if="$i%6==3"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower3.png"
              />
              <img
                v-else-if="$i%6==4"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower4.png"
              />
              <img
                v-else-if="$i%6==5"
                class="swiper-main-slide-black-flower-img"
                src="../../../assets/vows/flower5.png"
              />
            </div>
          </div>
          <div style="height:1.5rem;width:100%;"></div>
          <!-- <div class="swiper-bottom-text">和你一起走到世界的尽头</div> -->
        </div>
      </div>
    </div>
    <!-- 信息提示弹窗 -->
    <div v-if="popShow" class="message-pop"><div class="message-pop-text">{{popMessage}}</div></div>
  </div>
</template>
<script>
import axios from 'axios'
import GLOBAL from '../../../components/jiri/Global'
import browers from '../../../../plugins/browser.js'
import AppCall from '../../preview/appcall/utils/appcall.js'
import Swiper from 'swiper'
import 'swiper/css/swiper.min.css'
import Navbar from '../../../components/navbar/app.vue'
import Navtool from '../../../components/navtool/app.vue'
import Clipboard from 'clipboard'
import callapp from 'callapp'

window.HBHGlobal = ''
export default {
  components: {
    Navbar,
    Navtool
  },
  data() {
    return {
      isCanClick: true,
      popShow: false,
      popMessage: '',
      isIPhoneX: false,
      isApp: false,
      showTool: false, //显示工具导航
      touching: false, // 代表当前是否处于 下拉刷新行为的开关
      startY: 0, // 保存 滑动y轴点的位置
      cityId: '', //app携带cityId
      token: '',
      swiperObj: {},
      menuNav: [
        {
          vowsType1: 1,
          name: '婚礼誓词',
          list: [
            { vowsType2: 1, name: '新郎誓词', data: [] },
            { vowsType2: 2, name: '新娘誓词', data: [] }
          ]
        },
        {
          vowsType1: 2,
          name: '婚礼致辞',
          list: [
            { vowsType2: 1, name: '新郎父母致辞', data: [] },
            { vowsType2: 2, name: '新娘父母致辞', data: [] },
            { vowsType2: 3, name: '新郎亲友致辞', data: [] },
            { vowsType2: 4, name: '新娘亲友致辞', data: [] },
            { vowsType2: 5, name: '领导致辞', data: [] }
          ]
        },
        {
          vowsType1: 3,
          name: '接亲宣言',
          list: [],
          data: []
        }
      ],
      vowsType1: 1, //当前vowsType1选择参数
      vowsType2: 1, //当前vowsType2选择参数
      isGreater: GLOBAL.compareAppVersion('6.24.0').isGreater, //是否高于版本号 用于分享功能显示
    }
  },
  mounted() {
    var that = this
    // 隐藏app关闭按钮
    callapp('uiCloseBtn', { hide: 'true' })
    // 设置标题
    document.title = '婚礼致辞'
    AppCall.callapp('ui_webview_title', { title: '婚礼致辞' }, '')
    //判断是否为iphonex
    GLOBAL.setIPhoneX()
    that.isIPhoneX = GLOBAL.isIPhoneX
    // 获取token和城市ID
    that.getTokenAndCity()
    // 判断是否为app内
    that.isApp = browers().isApp
    // 判断是否为微信内
    that.isWeiXin = GLOBAL.isWeiXin()
    //初始化数据
    // that.getHomeInfo()
    //加载swiper
    that.$nextTick(function() {
      that.swiperObj = new Swiper('.swiper-container', {
        autoHeight: true,
        on: {
          touchStart: function(event) {
            // console.log("touchStart",event);
            that.touchStart()
          },
          slideChange: function() {
            // console.log('改变了，activeIndex为'+this.activeIndex);
            that.slideChange(this.activeIndex)
          }
        }
      })
    })
    //初始化数据
    that.getdata(that.vowsType1, that.vowsType2)
    //数据上报
    window.$action = new postdata({ 
      appkey: 'hunbasha_wap',
      pageName:location.pathname,
      sensor_option:{
        openAll:true
      }
    })
  },
  methods: {
    getdata(type1, type2) {
      var that = this
      var vowsData =
        type1 == 3
          ? that.menuNav[type1 - 1]
          : that.menuNav[type1 - 1].list[type2 - 1]
      if (vowsData.data.length > 0) {
        return
      }
      // 后台API请求参数
      let requestData = {
        vowsType1: type1,
        vowsType2: type2,
        pageSize: 999,
        pageNum: 1
      }
      //获取城市列表信息
      axios
        .post(GLOBAL.getUrlDomainForVows() + 'get-home-info', requestData, {
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
            'city-id': that.cityId,
            Authorization: that.token
          }
        })
        .then(function(result) {
          var code = result.data.code
          // 成功
          if (code === 0) {
            if (that.vowsType1 == 3) {
              that.menuNav[type1 - 1].data = result.data.data
            } else {
              that.menuNav[type1 - 1].list[type2 - 1].data = result.data.data
            }
            that.$nextTick(function() {
              that.swiperObj.update(true)
            })
          } else if (code === -1) {
            that.popMessage = result.data.message
            that.popShow = true
            // 1秒后自动关闭收藏信息提示弹窗
            setTimeout(that.closePop, 1000)
            // console.log(result.data.message)
          }
        })
    },
    /**
     * 触摸时加载上下两页数据
     */
    touchStart() {
      var that = this
      if (that.vowsType1 == 3) {
        return
      }
      //主tags对象
      var menuNavObj = that.menuNav[that.vowsType1 - 1]
      //加载前一页数据
      if (that.vowsType2 - 1 > 1) {
        that.getdata(that.vowsType1, that.vowsType2 - 1)
      }
      //加载后一页数据
      if (menuNavObj.list.length > that.vowsType2) {
        that.getdata(that.vowsType1, that.vowsType2 + 1)
      }
    },
    /**
     * 切换swiper
     */
    slideChange(index) {
      var that = this
      let subList = that.menuNav[that.vowsType1 - 1].list
      if (index > subList.length - 1) {
        return
      }
      that.vowsType2 = subList[index].vowsType2
      document.getElementById('subnavBlack' + (index>=2 ? subList.length-1 : 0)).scrollIntoView(false)
      // $('#subnavBlack'+index).scrollIntoView();
    },
    /**
     * 切换主tags
     */
    toggleMainTags(vowsType1) {
      var that = this
      if (that.vowsType1 == vowsType1) {
        return
      }
      that.vowsType1 = vowsType1
      that.vowsType2 = 1
      if (that.vowsType1 == 3) {
        that.vowsType2 = ''
      }
      that.getdata(that.vowsType1, that.vowsType2)
      that.swiperObj.slideTo(that.vowsType2 - 1)
      that.$nextTick(function() {
        that.swiperObj.update(true)
      })
    },
    /**
     * 切换子tags
     */
    toggleSubTags(vowsType2) {
      var that = this
      if (that.vowsType2 == vowsType2) {
        return
      }
      that.vowsType2 = vowsType2
      that.getdata(that.vowsType1, that.vowsType2)
      that.swiperObj.slideTo(that.vowsType2 - 1)
    },
    /**
     * 切换msg收起打开状态
     */
    vowsMsgOpen(vowsType1, vowsType2, index) {
      var that = this
      // console.log(vowsType1,vowsType2,index);
      if (that.vowsType1 == 3) {
        var openState = that.menuNav[vowsType1 - 1].data[index].openState
          ? false
          : true
        that.$set(
          that.menuNav[vowsType1 - 1].data[index],
          'openState',
          openState
        )
      } else {
        var openState = that.menuNav[vowsType1 - 1].list[vowsType2 - 1].data[
          index
        ].openState
          ? false
          : true
        that.$set(
          that.menuNav[vowsType1 - 1].list[vowsType2 - 1].data[index],
          'openState',
          openState
        )
      }
      that.$nextTick(function() {
        that.swiperObj.update(true)
      })
    },
    /**
     * 复制到剪切板
     */
    copyLink(data, vowsId, index) {
      var that = this
      // 防止重复点击
      if (!that.isCanClick) {
        return
      }
      that.isCanClick = false
      // console.log(data,vowsId,index)
      if (!/^dmp/.test(that.token)) {
        if (browers().isApp) {
          AppCall.callapp('loginApp', {}, 'location.reload')
        } else {
          GLOBAL.h5Login(location.href)
        }
        return
      }
      let clipboard = new Clipboard('.copy-line', {
        text: function() {
          return data
        }
      })
      clipboard.on('success', e => {
        // 后台API请求参数
        let requestData = {
          vowsId: vowsId
        }
        //获取城市列表信息
        axios
          .post(
            GLOBAL.getUrlDomainForVows() + 'post-update-copy-count',
            requestData,
            {
              headers: {
                'Content-Type': 'application/json;charset=utf-8',
                'city-id': that.cityId,
                Authorization: that.token
              }
            }
          )
          .then(function(result) {
            var code = result.data.code
            // 成功
            if (code === 0) {
              // console.log('复制成功');
              that.popMessage = '复制成功'
              that.popShow = true
              // 1秒后自动关闭收藏信息提示弹窗
              setTimeout(that.closePop, 1000)
              let vows =
                that.vowsType1 == 3
                  ? that.menuNav[that.vowsType1 - 1].data[index]
                  : that.menuNav[that.vowsType1 - 1].list[that.vowsType2 - 1]
                      .data[index]
              vows.vowsCopyCount++
            } else if (code === -1) {
              that.popMessage = result.data.message
              that.popShow = true
              // 1秒后自动关闭收藏信息提示弹窗
              setTimeout(that.closePop, 1000)
            }
          })
          .finally(function() {
            that.isCanClick = true
          })
        // 释放内存
        clipboard.destroy()
      })
      clipboard.on('error', e => {
        // console.log('复制失败');
        that.popMessage = '复制失败'
        that.popShow = true
        // 1秒后自动关闭收藏信息提示弹窗
        setTimeout(that.closePop, 1000)
        clipboard.destroy()
        that.isCanClick = true
      })
    },
    /**
     * 跳转url
     */
    goUrl(url) {
      location.assign(url)
    },
    /**
     * 关闭信息提示弹窗
     */
    closePop() {
      var that = this
      that.popShow = false
      that.popMessage = ''
    },
    /**
     * 获取token和城市ID
     */
    getTokenAndCity() {
      var that = this
      // 城市ID从任务index读取
      that.cityId = GLOBAL.getCookie('city-id')
      // token
      that.token = GLOBAL.getCookie('Authorization')
      //areaCode
      that.areaCode = sessionStorage.getItem('registryAreaCode')
    },
    /**
     * 导航条跳转地址
     */
    navToUrl(url) {
      var that = this
      // console.log(url)
      if (url == null) {
        location.assign(GLOBAL.getIndexPage())
      } else {
        location.assign(url)
      }
    },
    /**
     * 小助手导航显示
     */
    openToolEvent(){
      var that = this
      that.showTool = true
    },
    /**
     * 小助手导航隐藏
     */
    closeToolEvent(){
      var that = this
      that.showTool = false
    },
    
  }
}
</script>

<style>
body {
  margin: 0 !important;
}
.vows-page {
  width: 100%;
  min-height: 100vh;
  font-family: PingFangSC-Medium;
  background: rgba(255, 255, 255, 1);
  background-repeat: no-repeat;
}
.head-content {
  width: 37.5rem;
  height: 10rem;
  margin-top: 1.45rem;
  position: relative;
}
.head-content-img {
  width: 34.5rem;
  height: 10rem;
  border-radius: 1rem;
  margin-left: 1.5rem;
  position: absolute;
  top: 0;
  left: 0;
}

.mainnav-line {
  height: 2.95rem;
  width: 31.4rem;
  margin: 1.95rem 3.05rem 0 3.05rem;
}
.mainnav-black {
  height: 2.95rem;
  width: 7.3rem;
  float: left;
  margin-left: 4.75rem;
}
.mainnav-black:first-of-type {
  margin-left: 0;
}
.mainnav-tags {
  width: 7.3rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.4rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
.mainnav-tags-select {
  width: 7.3rem;
  height: 1.75rem;
  line-height: 1.75rem;
  font-size: 1.8rem;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
.mainnav-tags-select-wire {
  width: 2.5rem;
  height: 0.25rem;
  background: rgba(255, 59, 80, 1);
  border-radius: 0.15rem;
  margin: 0 auto;
  margin-top: 0.95rem;
}

.subnav-line {
  display: flex;
  padding-left: 1.5rem;
  margin-top: 1.5rem;
  overflow-x: auto;
  white-space: nowrap;
  width: auto;
}
::-webkit-scrollbar {
  display: none;
}
.subnav-black {
  height: 4rem;
  margin-left: 0.5rem;
  display: inline-block;
}
.subnav-black:first-of-type {
  margin-left: 0;
}
.subnav-black-button {
  height: 4rem;
  background: rgba(248, 248, 248, 1);
  line-height: 4rem;
  border-radius: 0.5rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  color: rgba(51, 51, 51, 1);
  padding: 0 1rem;
}
.subnav-black-button-select {
  height: 4rem;
  background: linear-gradient(
    90deg,
    rgba(255, 85, 66, 1) 0%,
    rgba(255, 59, 80, 1) 100%
  );
  line-height: 4rem;
  border-radius: 0.5rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 500;
  text-align: center;
  color: rgba(255, 255, 255, 1);
  padding: 0 1rem;
}

.swiper-container {
  width: 100%;
}
.swiper-wrapper {
  width: 100%;
}
.swiper-main-slide-page {
  width: 100%;
}
.swiper-main-slide-black {
  width: 31.35rem;
  margin: 1.5rem 1.5rem 0 1.5rem;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0rem 0.15rem 1.5rem 0rem rgba(51, 51, 51, 0.1);
  border-radius: 1rem;
  padding: 3.35rem 1.65rem 0 1.5rem;
  position: relative;
}

.swiper-main-slide-black-flower {
  width: 8.5rem;
  height: 3rem;
  position: absolute;
  top: 0;
  right: 0;
}
.swiper-main-slide-black-flower-img {
  width: 8.5rem;
  height: 3rem;
}

.swiper-main-text {
  position: relative;
  width: 32rem;
  max-height: 8.8rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 2.2rem;
  overflow: hidden;
  white-space: pre-line;
}
.swiper-main-text-all {
  position: relative;
  width: 32rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 2.2rem;
  white-space: pre-line;
}
.swiper-main-btn-line {
  width: 31.35rem;
  height: 3rem;
  margin-top: 2.2rem;
  padding: 0.5rem 0;
  border-top: 0.05rem solid rgba(245, 245, 245, 1);
}
.swiper-main-btn-lateral {
  width: 15.6rem;
  height: 3rem;
  font-size: 1.3rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 3rem;
  text-align: center;
  float: left;
  border-left: 0.05rem solid rgba(245, 245, 245, 1);
}
.swiper-main-btn-lateral:first-of-type {
  border-left: none;
}

.swiper-main-btn-lateral-line {
  width: 100%;
  height: 3rem;
  font-size: 1.3rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 3rem;
  text-align: center;
  float: left;
}

.swiper-main-btn-copy-img {
  width: 1rem;
  height: 1rem;
  position: relative;
  top: 0.1rem;
  margin-right: 0.4rem;
  margin-left: 0.1rem;
}
.swiper-main-btn-share-img {
  width: 1rem;
  height: 1rem;
  position: relative;
  top: 0.1rem;
  left: 0.4rem;
}

.swiper-bottom-text {
  width: 100%;
  height: 1.15rem;
  font-size: 1.2rem;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 1.15rem;
  text-align: center;
  margin: 2rem 0;
}

.text-line{
  display: inline-block;
  text-align: left;
}

.vows-msg-pack-up {
  position: relative;
  display: inline-block;
  width: 4.5rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 2rem;
  text-align: left;
  color: rgba(255, 59, 80, 1);
}
.vows-msg-open-up {
  position: relative;
  display: inline-block;
  width: 7.5rem;
  font-size: 1.5rem;
  font-family: PingFang SC;
  font-weight: 400;
  line-height: 2rem;
  text-align: left;
  color: rgba(255, 59, 80, 1);
  background: rgba(255, 255, 255, 1);
  z-index: 2;
}
.vows-msg-arrow-img {
  position: absolute;
  width: 1.1rem;
  height: 0.6rem;
  top: 0.7rem;
  right: 0.1rem;
}
.message-pop {
  height: 5rem;
  position: fixed;
  left:0;
  right:0;
  top:0;
  bottom:0;
  margin:auto;
  text-align: center;
  opacity: 0.9;
  z-index: 999;
}
.message-pop-text{
  display: inline-block;
  padding: 0 2.3rem;
  line-height: 5rem;
  text-align: center;
  font-family: 'PingFangSC-Regular';
  border-radius: 1rem;
  color: #f5f8fa;
  font-size: 1.4rem;
  font-weight:500;
  background-color: #333333;
  margin:auto;
  opacity: 0.9;
}
</style>
